import React from 'react';
import { Grid2, styled, Typography } from '@mui/material';
import { LibraryCard } from 'components/LibraryCard/LibraryCard';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { TransformedLibraryArticle } from 'features/resources/types';
import { RESOURCE_LAYOUT_GRID_COLUMNS } from 'themes/constants';

const CenteredGrid2 = styled(Grid2)(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

const Container = styled(Grid2)(({ theme }) => ({
  marginTop: theme.spacing(2.5),
}));

interface ResourceDesktopFavouritesProps {
  favoritedArticles: TransformedLibraryArticle[];
  allArticlesLabel: string;
  handleArticleClick?: (article: TransformedLibraryArticle) => void;
  onToggleFavorite: (article: TransformedLibraryArticle) => void;
}

// Desktop-only "Favorites" preview row + "All Articles" label above the full article list (WFMOB-16440).
export const ResourceDesktopFavourites = ({
  favoritedArticles,
  allArticlesLabel,
  handleArticleClick,
  onToggleFavorite,
}: ResourceDesktopFavouritesProps) => {
  const { translation } = useTranslationContext();

  return (
    <>
      <Grid2 size={RESOURCE_LAYOUT_GRID_COLUMNS}>
        <Typography color="grey.800" variant="title3">
          {translation('favorites_header')}
        </Typography>
      </Grid2>
      {favoritedArticles.map((article) => (
        <CenteredGrid2 key={`favorite-${article.id}`} size={2}>
          <LibraryCard
            title={article.title}
            imageUrl={article.imageUrl}
            onClick={() => handleArticleClick?.(article)}
            ariaLabel={`${article.title} article`}
            showFavorite
            isFavorited
            onToggleFavorite={() => onToggleFavorite(article)}
          />
        </CenteredGrid2>
      ))}
      <Container size={RESOURCE_LAYOUT_GRID_COLUMNS}>
        <Typography color="grey.800" variant="title3">
          {allArticlesLabel}
        </Typography>
      </Container>
    </>
  );
};
